var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qingwu"},[_c('el-carousel',{attrs:{"height":_vm.height}},_vm._l((_vm.list),function(v,k){return _c('el-carousel-item',{key:k},[_c('div',{staticClass:"shop_banner",style:('background-position: center;background-image:url(' +
              v.imgUrl +
              ');')},[_c('router-link',{attrs:{"to":'#'}})],1)])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }